import React from "react"
import ShiftTemplates from "./shift-templates/ShiftTemplates"
import PatternTemplates from "./pattern-templates/PatternTemplates"
import ScheduleTemplates from "./schedule-templates/ScheduleTemplates"
import MasterSchedules from "./master-schedules/MasterSchedules"
import SchedulePlanners from "./schedule-planners/SchedulePlanners"
import PostedSchedules from "./posted-schedules/PostedSchedules"
import strings from "../../localization/strings"

const Schedule: React.SFC<any> = (props: any) => {
  document.title = `${strings.Schedules} | ${strings.Findd_Grandd_Central}`
  switch (props.params.filter) {
    case "shift_templates":
      return <ShiftTemplates />
    case "pattern_templates":
      return <PatternTemplates />
    case "schedule_templates":
      return <ScheduleTemplates />
    case "master_schedules":
      return <MasterSchedules />
    case "schedule_planners":
      return <SchedulePlanners />
    case "posted_schedules":
      return <PostedSchedules />
  }
}

export default Schedule